import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	restoreDefaults: {
		id: 'issue-navigator.issue-results.list-view.column-picker-popup-component.column-picker-tabs.tab.restore-defaults',
		defaultMessage: 'Restore defaults',
		description: 'Label for "Restore defaults" button inside of column configuration',
	},
});
